function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Delivery = function Delivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M12.269 3c1.104 0 2 .897 2 2v.762h3.543c1.113 0 2.129.611 2.65 1.595l2.075 3.91c.229.431.35.918.35 1.406v6.167a1 1 0 0 1-1 1l-1.445.001a3.04 3.04 0 0 1-2.864 2.032c-1.322 0-2.45-.85-2.864-2.032H9.738a3.04 3.04 0 0 1-2.865 2.032 3.04 3.04 0 0 1-2.863-2.032H3c-1.103 0-2-.898-2-2V4.998c0-1.102.897-2 2-2zM6.873 17.806c-.569 0-1.033.464-1.033 1.033a1.034 1.034 0 0 0 2.067 0c0-.569-.464-1.033-1.034-1.033m10.705 0c-.57 0-1.034.464-1.034 1.033a1.035 1.035 0 0 0 2.067 0c0-.569-.464-1.033-1.033-1.033m.234-10.045h-3.543V17.84h.445a3.04 3.04 0 0 1 2.864-2.033c1.323 0 2.45.85 2.864 2.034h.445v-5.168c0-.163-.04-.325-.116-.469l-2.076-3.91a1 1 0 0 0-.883-.532M12.269 13.8h-9.27v4.04h1.01a3.04 3.04 0 0 1 2.864-2.033c1.323 0 2.451.85 2.865 2.034h2.53zm0-8.8h-9.27v6.8h9.27z"
  }));
};
export default Delivery;